import React, { useEffect, useState } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { matchRoutes } from 'react-router-config';
import { SearchStyle } from '../Config';
import { triggerCallback } from '../clientApi';
import { useSelector } from '../actions/types';
import { usePageNav } from '../hooksInternal/usePageNav';
import { getBaseUrl } from '../utils/routes';
import HomePage from '../pages/home';
import CategoryPage from '../pages/category';
import ArticlePage from '../pages/article';
import SearchPage from '../pages/search';
import Error404Page from '../pages/error404';
import ExtraPage from '../pages/extra';
import { getScrollIntoViewAnchor, SCROLL_DELAY_MS } from '../utils/scroll';
const baseUrl = getBaseUrl();
const baseRoutes = [
    {
        component: ArticlePage,
        path: `${baseUrl}/articles/:articleId`,
        exact: true,
    },
    {
        component: CategoryPage,
        path: `${baseUrl}/categories/:categoryId`,
        exact: true,
    },
    {
        component: HomePage,
        path: `${baseUrl}/`,
        exact: true,
    },
];
const searchRoute = {
    component: SearchPage,
    path: `${baseUrl}/search`,
    exact: true,
};
export function getRoutes(config) {
    let routes = baseRoutes;
    // Add the search route if we are using results page routing.
    if (!config.searchStyle || config.searchStyle === SearchStyle.resultsPage) {
        routes = routes.concat(searchRoute);
        // Make sure there is a search page defined.
        if (!config.pages.search) {
            throw new Error('Search page must be defined when not using dropdown search style');
        }
    }
    // Wrap the Extra pages in our extra page component.
    const extraPages = (config.extraPages || []).map((r) => ({
        ...r,
        component: () => React.createElement(ExtraPage, { page: r.component }),
        path: `${baseUrl}/${r.path}`,
    }));
    return routes.concat(extraPages).concat({
        // 404 route needs to be the last one.
        component: Error404Page,
        path: '*',
    });
}
const AppRoutes = ({ children, routes }) => {
    const location = useLocation();
    const [oldLocation, setOldLocation] = useState(location);
    const currentPage = useSelector((state) => state.page.currentPage);
    const [oldCurrentPage, setOldCurrentPage] = useState(currentPage);
    const matchedRoutes = matchRoutes(routes, location.pathname);
    if (matchedRoutes.length === 0) {
        throw new Error("Not matched routes, this shouldn't happen");
    }
    usePageNav(matchedRoutes[0]);
    if (oldCurrentPage !== currentPage) {
        setOldCurrentPage(currentPage);
        setOldLocation(location);
    }
    useEffect(() => {
        // Fire off page:change event
        triggerCallback('page:change', {
            url: document.location.toString(),
        });
        // Scroll to anchor on route change, else scroll to top if no anchor exists
        const anchor = getScrollIntoViewAnchor(document);
        if (anchor) {
            /**
             * Need to allow time for page content to render/draw before scrolling to anchors.
             * Otherwise the element heights are prematurely calculated and the scroll
             * does not go all the way down to the element.
             */
            setTimeout(() => {
                anchor.scrollIntoView({ behavior: 'smooth' });
            }, SCROLL_DELAY_MS);
        }
        else {
            window.scrollTo(0, 0);
        }
    }, [currentPage]);
    return React.createElement(Route, { location: oldLocation, render: () => children });
};
AppRoutes.displayName = 'AppRoutes';
export default AppRoutes;
//# sourceMappingURL=Routes.js.map